import React from "react";
import { ReactComponent as DocxIcon } from "../../images/filetypes/docx.svg";
import { ReactComponent as PdfIcon } from "../../images/filetypes/pdf.svg";
import { ReactComponent as JpgIcon } from "../../images/filetypes/jpg.svg";
import { ReactComponent as XlsIcon } from "../../images/filetypes/xls.svg";
import { ReactComponent as PngIcon } from "../../images/filetypes/png.svg";
import { ReactComponent as TxtIcon } from "../../images/filetypes/txt.svg";
import { ReactComponent as UnknownIcon } from "../../images/filetypes/unknown.svg";

const ICONS_MAP = {
    "image/jpeg": JpgIcon,
    "image/png": PngIcon,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": XlsIcon,
    "application/vnd.ms-excel": XlsIcon,
    "application/msword": DocxIcon,
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": DocxIcon,
    "application/pdf": PdfIcon,
    "text/plain": TxtIcon
};

export const FileIcon = props => {
    const { mimeType } = props;
    const FileIcon = ICONS_MAP[mimeType];
    return FileIcon ? <FileIcon /> : <UnknownIcon />;
};
